module.exports = __webpack_public_path__ + "static/media/6.89e9dde2.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/eyes/6.png
// module id = 633
// module chunks = 0